import React, { useContext } from 'react';
import { CotizadorContext } from '../context';

const useRentTimeData = () => {
    const [state, setState] = useContext(CotizadorContext)

    const setUnit = unit => {
        setState(prevState => ({
            ...prevState,
            unit
        }));
    }

    const setAmount = amount => {
        setState(prevState => ({
            ...prevState,
            amount
        }));
    }

    const getSelectedUnitLabel = () => {
        if (state.unit) {
            return state.unit_options.find(item => item.value === state.unit).label;
        }

        return null;
    }
    
    const setSelectedDiscount = discount => {
        setState(prevState => ({
            ...prevState,
            selected_discount: discount
        }));
    }

    const getDiscounts = () => {
        return state.discounts
    }
    
    const getSelectedDiscount = () => {
        return state.selected_discount
    }

    return {
        unit_options: state.unit_options,
        unit: state.unit,
        amount: state.amount,
        setUnit,
        setAmount,
        getSelectedUnitLabel,
        setSelectedDiscount,
        getSelectedDiscount,
        getDiscounts
    };

}

export default useRentTimeData;